/* eslint-disable no-param-reassign */
import * as yup from 'yup'

export function createYupSchema(schema, config) {
  const { id, validationType, validations = [] } = config
  if (!yup[validationType]) {
    return schema
  }
  let validator = yup[validationType]()
  validations.forEach((validation) => {
    const { params, type } = validation
    if (!validator[type]) {
      return
    }
    if (type === 'when') {
      const [field, options] = params
      validator = validator.when(field, (value, conditionSchema) => {
        if (options.is(value)) {
          return conditionSchema.required(options.then.message).trim()
        }
        return conditionSchema
      })
    } else {
      validator = validator[type](...params)
    }
  })
  schema[id] = validator
  return schema
}
